import { Link as RouterLink } from 'react-router';
import { Button } from '../ui/components';

const NotFoundPage = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <div style={{ padding: 32, textAlign: 'center', maxWidth: 500, border: '1px solid var(--ds-border-default)', borderRadius: 'var(--ds-border-radius-large)', backgroundColor: 'var(--ds-bg-primary)' }}>
        <h1 style={{ fontSize: '5rem', fontWeight: 700, marginBottom: 16, color: 'var(--ds-text-primary)' }}>
          404
        </h1>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: 12, color: 'var(--ds-text-primary)' }}>
          Page Not Found
        </h2>
        <p style={{ fontSize: '1rem', color: 'var(--ds-text-secondary)', marginBottom: 24 }}>
          The page you are looking for doesn't exist or has been moved.
        </p>
        <RouterLink to="/" style={{ textDecoration: 'none' }}>
          <Button variant="primary" size="lg">Go to Home</Button>
        </RouterLink>
      </div>
    </div>
  );
};

export default NotFoundPage;
